<template>
    <component :is="display" :props="props" />
</template>

<script setup>
import { useUser } from "@/Composables";
import SourcingPagination from "../../../Themes/Sourcing/Components/Modules/Search/SearchSimplePagination.vue";
import MarketingPagination from "../../../Themes/Marketing/Components/Modules/Search/SearchSimplePagination.vue";
import { computed } from "vue";

const { settings } = useUser();
const display = computed(() =>
    settings.value.is_sourcing_mode ? SourcingPagination : MarketingPagination
);

defineProps(["props"]);
</script>
